export default "__VITE_ASSET__BJjXfA6I__"